import { useCallback } from "react";
const useForgotPassword = (authImplementation) => {
  return useCallback(
    async (username) => {
      if (authImplementation.forgotPassword) {
        return await authImplementation.forgotPassword(username);
      } else {
        throw new Error(
          `Auth client ${authImplementation.type} does not implement this function`
        );
      }
    },
    [authImplementation]
  );
};
export {
  useForgotPassword
};
